import React from 'react'
import { CCard, CCardHeader, CCardBody, CRow, CCol, CAvatar } from '@coreui/react'
import { useSelector } from 'react-redux'

const Profile = () => {
  const { adminProfile } = useSelector((state) => state.adminprofile)

  if (!adminProfile?.profile) {
    return <div>Loading profile...</div>
  }

  return (
    <CRow>
      <CCol xs={12} md={6} lg={6}>
        <CCard>
          <CCardHeader>
            <strong>Admin Profile</strong>
          </CCardHeader>
          <CCardBody>
            <div className="d-flex align-items-center mb-4">
              <div className="image-size">
                <CAvatar
                  size="lg"
                  src={adminProfile.profile}
                  alt={adminProfile.name}
                  className="image-profile"
                />
              </div>

              <div className="m-3">
                <h5 className="mb-0">{adminProfile.name}</h5>
                <small className="text-muted">{adminProfile.user_type}</small>
              </div>
            </div>

            <CRow className="mb-2">
              <CCol xs={4}>Username:</CCol>
              <CCol xs={8}>
                <strong>{adminProfile.username}</strong>
              </CCol>
            </CRow>
            <CRow className="mb-2">
              <CCol xs={4}>Email:</CCol>
              <CCol xs={8}>
                <strong>{adminProfile.email_id}</strong>
              </CCol>
            </CRow>
            <CRow className="mb-2">
              <CCol xs={4}>Mobile No:</CCol>
              <CCol xs={8}>
                <strong>{adminProfile.mobile_no}</strong>
              </CCol>
            </CRow>
            <CRow className="mb-2">
              <CCol xs={4}>Status:</CCol>
              <CCol xs={8}>
                <strong>{adminProfile.status}</strong>
              </CCol>
            </CRow>
            <CRow className="mb-2">
              <CCol xs={4}>User Code:</CCol>
              <CCol xs={8}>
                <strong>{adminProfile.user_code}</strong>
              </CCol>
            </CRow>
            <CRow>
              <CCol xs={4}>Created At:</CCol>
              <CCol xs={8}>
                <strong>{new Date(adminProfile.createdAt).toLocaleString()}</strong>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  )
}

export default Profile
